import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    findOutMoreLink: 'I want to know more',

    pleaseContactUs: 'Please contact us for more information.',
    title: 'You cannot open an account with us',
    unsupportedJob: {
      description:
        'We regret to inform you that we do not yet support this activity type. To learn more, please read the following article:',
      linkLabel: 'What activities Shine does not accept?',
    },
  },
  fr: {
    findOutMoreLink: 'En savoir plus',
    pleaseContactUs: 'Merci de nous contacter pour avoir plus d’informations.',
    title: 'Ce service n’est pas disponible pour vous',
    unsupportedJob: {
      description:
        'Nous sommes dans le regret de vous annoncer que nous ne supportons pas encore ce type d’activité. Pour en savoir plus, nous vous invitons à consulter l’article suivant\u00A0:',
      linkLabel: 'Quelles sont les activités que Shine n’accepte pas\u00A0?',
    },
  },
} as const);

export default locales;
